


























import { Component, Prop, Vue } from 'vue-property-decorator'
import FormBase from '@/shared/classes/form/form-base'
import Form from '@/shared/components/form/Form.vue'
import Field, { FieldSizes } from '@/shared/classes/form/field'
import ArrayField from '@/shared/classes/form/fields/array-field'
import { FieldTypes } from '@/shared/components/form/field-types'
import _ from 'lodash'
import __ from '@/shared/helpers/__'
import AddMultiplePhotosButton from '@/company/components/task-types/AddMultiplePhotosButton.vue'

@Component({
  components: { Form },
  methods: { __ }
})
export default class TaskTypeFilesDialog extends Vue {
  @Prop() field!: Field
  @Prop() form!: FormBase
  @Prop() fullKey!: string
  dialog: boolean = false

  photosForm: FormBase = new FormBase()
    .setFields([
      new ArrayField()
        .setKey('photos')
        .setTitle(__('company.components.task-types.task-type-files-dialog.form.photos'))
        .setChildren([
          new Field()
            .setType(FieldTypes.file)
            .setKey('file')
            .setTitle(__('company.components.task-types.task-type-files-dialog.form.file'))
            .setValue([])
            .setMeta({
              type: 'image',
              accept: 'image/*',
            })
            .setSize(FieldSizes.half),
          new Field()
            .setKey('description')
            .setTitle(__('company.components.task-types.task-type-files-dialog.form.description'))
            .setSize(FieldSizes.half)
        ])
        .setAdditionalActions([
          AddMultiplePhotosButton
        ])
        .setAddButton(() => false)
    ])
    .setOnSuccess((data: any) => {
      _.set(this.form.data, this.fullKey, data.photos.filter((photo: any) => {
        if (photo.file) {
          if (photo.file.length !== 0) return photo
        }
      }))

      this.onClose()
    })

  openDialog() {
    this.photosForm.setInitialValues({
      photos:
        _.get(this.form.data, this.fullKey) ? _.get(this.form.data, this.fullKey) :
        [
          {
            file: [],
            description: ''
          }
        ]
    })

    this.dialog = true
  }

  onClose() {
    this.dialog = false
  }
}
